import { render, staticRenderFns } from "./TopVideo.vue?vue&type=template&id=2590dc1e&"
import script from "./TopVideo.vue?vue&type=script&lang=js&"
export * from "./TopVideo.vue?vue&type=script&lang=js&"
import style0 from "./TopVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2590dc1e')) {
      api.createRecord('2590dc1e', component.options)
    } else {
      api.reload('2590dc1e', component.options)
    }
    module.hot.accept("./TopVideo.vue?vue&type=template&id=2590dc1e&", function () {
      api.rerender('2590dc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/savideo/components/TopVideo.vue"
export default component.exports